// extracted by mini-css-extract-plugin
module.exports = {"secondaryAction":"styles__secondaryAction___1EHtv"};